import { http } from '../../core/services/http';
import { UserType } from '../interfaces/UserType';
import transformLoadUserTypes from './transformLoadUserTypes';

const doLoadUserTypes = () =>
  http.get<UserType[]>('/common/systemTypes/userTypeValues').then(response => transformLoadUserTypes(response.data));

export default doLoadUserTypes;
